import React from "react";
import { Grid, Box, Typography, Paper, Button } from "@mui/material";

const experienceData = [
  { label: "Fresher", salary: "₹6 LPA", range: "₹5 LPA - ₹7 LPA" },
  { label: "1-2 Years", salary: "₹5 LPA", range: "₹5 LPA - ₹6 LPA" },
  { label: "3-4 Years", salary: "₹7 LPA", range: "₹7 LPA - ₹8 LPA" },
  { label: "5-6 Years", salary: "₹12 LPA", range: "₹11 LPA - ₹13 LPA" },
  { label: "7-8 Years", salary: "₹17 LPA", range: "₹16 LPA - ₹18 LPA" },
  { label: "9-10 Years", salary: "₹20 LPA", range: "₹18 LPA - ₹22 LPA" },
];

export default function AnnualIncome() {
  return (
    <>
      {/* Salary Section */}
      <Box
        sx={{
          backgroundColor: "#000",
          px: { xs: 2, sm: 6, md: 12, lg: 24 },
          py: 4,
        }}
      >
        <Typography
          sx={{
            fontFamily:
              "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            fontWeight: 600,
            fontSize: {
              xs: "28px", // extra small screens (mobile)
              sm: "36px", // small screens
              md: "48px", // medium screens
              lg: "56px", // large screens
            },
            lineHeight: {
              xs: "36px",
              sm: "46px",
              md: "58px",
              lg: "70px",
            },
            textAlign: "center",
            mb: {
              xs: "16px", // smaller margin on mobile
              sm: "20px",
              md: "24px",
              lg: "30px", // full 30px on large screens
            },
          }}
        >
          Annual Income Based on Years of Experience for Java
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {experienceData.map((item, idx) => (
            <Grid item key={idx} xs={6} sm={6} md={2}>
              <Paper
                elevation={0}
                sx={{
                  background: "linear-gradient(to bottom, #111, #000)",
                  borderRadius: "12px",
                  p: 2,
                  color: "#fff",
                  textAlign: "left",
                  border: "1px solid rgba(255,255,255,0.1)",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                    fontWeight: 600,
                    fontStyle: "bold",
                    fontSize: { xs: "14px", sm: "15px", md: "16px" },
                    lineHeight: { xs: "22px", sm: "24px", md: "26px" },
                    color: "#fff",
                    mb: 1,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                    fontWeight: 500,
                    fontStyle: "normal",
                    fontSize: { xs: "14px", sm: "15px", md: "16px" },
                    lineHeight: { xs: "22px", sm: "24px", md: "26px" },
                    color: "#fff",
                    mb: 0.5,
                  }}
                >
                  {item.salary}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                    fontWeight: 600,
                    fontStyle: "bold",
                    fontSize: { xs: "10px", sm: "11px", md: "12px" },
                    lineHeight: { xs: "18px", sm: "20px", md: "22px" },
                    color: "rgba(255,255,255,0.6)",
                  }}
                >
                  {item.range}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Typography
          sx={{
            fontFamily: "'SF Pro Display', 'Inter', sans-serif",
            fontWeight: 500,
            fontStyle: "normal",
            fontSize: { xs: "14px", sm: "16px", md: "18px" },
            lineHeight: { xs: "20px", sm: "23px", md: "26px" },
            textAlign: "center",
            color: "rgba(255,255,255,0.6)",
            mt: { xs: 2, sm: 3, md: 4 },
            mx: "auto",
          }}
        >
          Salary ranges are AI-generated estimates based on experience and
          country. Actual salaries may vary.
        </Typography>
      </Box>
    </>
  );
}
